import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { onError } from '@apollo/link-error';
export default onError(function (_ref) {
  var graphQLErrors = _ref.graphQLErrors,
      networkError = _ref.networkError;
  if (graphQLErrors) graphQLErrors.map(function (_ref2) {
    var message = _ref2.message,
        locations = _ref2.locations,
        path = _ref2.path;
    return (// eslint-disable-next-line no-console
      console.error("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path))
    );
  });

  if (networkError) {
    // eslint-disable-next-line no-console
    console.error("[Network error]: ".concat(networkError)); // eslint-disable-next-line no-console

    console.error("[Network error payload]: ".concat(JSON.stringify(networkError.result)));
  }
});